export default __webpack_public_path__ + "static/media/kvlogo.dba86158.svg";